import { render, staticRenderFns } from "./OrderHistory.vue?vue&type=template&id=75664218&scoped=true&"
import script from "./OrderHistory.vue?vue&type=script&lang=ts&"
export * from "./OrderHistory.vue?vue&type=script&lang=ts&"
import style0 from "./OrderHistory.vue?vue&type=style&index=0&id=75664218&scoped=true&lang=css&"
import style1 from "./OrderHistory.vue?vue&type=style&index=1&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "75664218",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCardTitle } from 'vuetify/lib/components/VCard';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VSlideYTransition } from 'vuetify/lib/components/transitions';
import { VSpacer } from 'vuetify/lib/components/VGrid';
installComponents(component, {VCardTitle,VCol,VContainer,VRow,VSlideYTransition,VSpacer})
